import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchReadList } from '@/api/PMS/estateManagement/notice/issueNotice';
export default {
  props: ['id', 'type', 'showDialog'],
  data: function data() {
    return {
      childData: {},
      list: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    getStr: function getStr(arr) {
      var res = '';

      if (arr === undefined || arr === null || arr.length === 0) {} else {
        arr.forEach(function (item) {
          res = res + item + ',';
        });
      }

      if (res !== '') {
        res = res.substring(0, res.length - 1);
      }

      return res;
    },
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.id > 0) {
        var queryData = {
          id: this.id,
          receiverObjectType: this.type
        };
        fetchReadList(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      }
    },
    handCancle: function handCancle() {
      this.$emit('handViewListCancle', false);
    }
  }
};